import React from 'react';
import './TemplateTextblockSelect.css';
import CustomDropdown from '../input/CustomDropdown';

/**
 * Textblock picker of the template editor (step mail targets, mail rules). The first option means
 * "no own textblock" (value null) and is labelled by the caller ("Erben …", "Aus der Mail-Regel …").
 * required: the empty option is only a prompt and cannot be chosen again (newsletter targets).
 * textblocks: [{ id, label }] from useTemplateReferenceData — null while loading.
 */
function TemplateTextblockSelect({ label, value, onChange, textblocks, emptyLabel, required = false, disabled = false }) {
  const list = textblocks ?? [];
  const current = value != null ? Number(value) : null;
  // Keep a referenced textblock visible while the list loads (or if it is not in the list).
  const missing = current != null && !list.some(tb => tb.id === current);

  return (
    <div className={`textFieldWrapper ptTextblockSelect${disabled ? ' isDisabled' : ''}`}>
      {label && <label className="textFieldLabel">{label}</label>}
      <CustomDropdown
        icon="description"
        value={current != null ? String(current) : ''}
        onChange={e => { if (!disabled) onChange?.(e.target.value ? Number(e.target.value) : null); }}
      >
        <option value="" disabled={required}>{emptyLabel}</option>
        {missing && <option value={String(current)}>{textblocks ? `Baustein #${current}` : 'Lädt …'}</option>}
        {list.map(tb => <option key={tb.id} value={String(tb.id)}>{tb.label}</option>)}
      </CustomDropdown>
    </div>
  );
}

export default TemplateTextblockSelect;
